// CRO-01 — Barre "Ajouter au panier" sticky mobile. Voir SHOPIFY.md.
// Aucune logique de panier dupliquée : le clic déclenche le vrai bouton du
// formulaire produit natif Dawn (AJAX cart standard, dynamic checkout inclus).
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.targetButton = document.getElementById(this.dataset.targetButtonId);
        this.button = this.querySelector('.sticky-atc__button');

        if (!this.targetButton || !this.button) return;

        this.button.addEventListener('click', () => this.targetButton.click());

        this.removeAttribute('hidden');

        this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries), {
          rootMargin: '0px 0px -10% 0px',
        });
        this.observer.observe(this.targetButton);
      }

      handleIntersection(entries) {
        const targetIsVisible = entries[0].isIntersecting;
        if (targetIsVisible) {
          this.removeAttribute('data-visible');
        } else {
          this.setAttribute('data-visible', '');
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
